import logger from 'lib/logger';
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/store';
import { Userpilot } from 'userpilot';

export enum EGAEventName {
    MenuSwitch = 'menu-switch',
    CalculatedRefundAttempt = 'calculated_refund_attempt',
    CustomRefundAttempt = 'custom_refund_attempt',
    RefundAllAttempt = 'refund_all_attempt',
    StandalonePaymentRefund = 'standalone_refund_attempt',
    StandaloneRefundAllAttempt = 'standalone_refund_all_attempt',
    PerkVisualisationTitleClick = 'perk_visualisation_title_click',
    TransactionsFilterBulk = 'transactions_filter_bulk',
    NotificationsTitleInputClick = 'notifications_title_input_click',
    ScopeMatchCodeAddConditionClick = 'scope_match_code_add_condition_click',
    AudienceAnalyticsMeasureClick = 'audience_analytics_measure_click',
    AudienceAnalyticsDateRangeChange = 'audience_analytics_date_range_change',
    AudienceAnalyticsAudiencesSelected = 'audience_analytics_audiences_selected',
    ViewAudienceAnalyticsBannerClick = 'view_audience_analytics_banner_click'
}

export function useGAHelpers() {
    const { tenant, claims } = useSelector((state: ApplicationState) => state.auth);
    const logUserEvent = React.useCallback(
        (eventName: string, additionalData?: Record<string, any>) => {
            try {
                if (window.gtag) {
                    window.gtag('event', eventName, {
                        user: claims?.authId,
                        // TODO: remove merchantId after confirming with product team, but not earlier than Sep 2025
                        merchantId: tenant?.tenantId,
                        tenantId: tenant?.tenantId,
                        ...additionalData
                    });
                } else {
                    logger.warn('No GTAG');
                }
                // Duplicate event and send it to userpilot
                if (process.env.NODE_ENV === 'production') {
                    Userpilot.track(eventName, {
                        user: claims?.authId,
                        tenantId: tenant?.tenantId,
                        ...additionalData
                    });
                }
            } catch (e) {
                logger.error(e.message, e);
            }
        },
        [claims?.authId, tenant?.tenantId]
    );
    return { logUserEvent };
}
